import React from 'react';

/**
 * Sélecteur d'options (suppléments) — même règles que le natif :
 * toutes facultatives, max par groupe, supplément affiché, instructions libres.
 * Contrôlé : value = [{group_id, group_name, option_id, name, price_delta}].
 */
export default function OptionsPicker({ groups = [], value = [], onChange, instructions, onInstructions }) {
  const isOn = (g, o) => value.some(v => v.group_id === g.group_id && v.option_id === o.option_id);
  const toggle = (g, o) => {
    if (isOn(g, o)) {
      onChange(value.filter(v => !(v.group_id === g.group_id && v.option_id === o.option_id)));
      return;
    }
    const inGroup = value.filter(v => v.group_id === g.group_id).length;
    if (g.max_selections > 0 && inGroup >= g.max_selections) return; // plafond atteint
    onChange([...value, {
      group_id: g.group_id, group_name: g.name,
      option_id: o.option_id, name: o.name, price_delta: o.price_delta || 0,
    }]);
  };

  return (
    <div>
      {groups.map(g => {
        const opts = (g.options || []).filter(o => o.is_available !== false);
        if (!opts.length) return null;
        return (
          <div className="mk-optgroup" key={g.group_id}>
            <h4>
              {g.name}
              {g.max_selections > 0 && <small>max {g.max_selections}</small>}
            </h4>
            {opts.map(o => {
              const on = isOn(g, o);
              return (
                <button type="button" key={o.option_id} className={`mk-opt${on ? ' on' : ''}`} onClick={() => toggle(g, o)}>
                  <span className="box">{on ? '✓' : ''}</span>
                  <span className="name">{o.name}</span>
                  {(o.price_delta || 0) > 0 && <span className="delta">+{(o.price_delta || 0).toLocaleString('fr-FR')} FC</span>}
                </button>
              );
            })}
          </div>
        );
      })}
      <div className="mk-optgroup">
        <h4>Instructions particulières</h4>
        <textarea
          className="mk-instr"
          value={instructions}
          onChange={e => onInstructions(e.target.value)}
          placeholder="Ex. sans oignons, bien cuit…"
          maxLength={300}
        />
      </div>
    </div>
  );
}
